<template>
  <div class="Genswell">
        <FeatureMain
          Card_subtitle="Sound Control Solution"
          Card_title="젠스웰은 운전의 즐거움을 주기위한 다양한 사운드 솔루션 입니다."
          Card_description="엔진음을 풍부하게 해주고, 시트에 장착하여 풍부한 우퍼효과와 진동을 전달하여 운전에 재미를 주고, 다이나믹한 배기음으로 고성능 차량의 아이덴티티를 살리는 기술과 제품으로 새로운 시장을 개척하고자 합니다."
          ImageSrc="genswell_main.png"
          />

        <FeatureSubs
            Card_subtitle="Electronic Sound Generator"
            Card_title="ESG"
            Card_description="Electronic sound generator is a device that produces enhanced engine sound. The driver can therefore feel as if he is driving a high-performance car."
            ImageSrc1="genswell_1_1.png"
            ImageSrc2="genswell_1_2.png"/>
        <FeatureSubs
            Card_subtitle="Vibrating Woofer Seat"
            Card_title="VWS"
            Card_description="Vibration woofer seat is a device that delivers media woofer effect and warning vibration to passengers through seat vibration."
            ImageSrc1="genswell_2_1.png"
            ImageSrc2="genswell_2_2.png"/>
        <FeatureSubs
            Card_subtitle="Electronic Control Exhaust Value"
            Card_title="ECEV"
            Card_description="Active variable valve is a device that controls the acceleration and sporty sound of the vehicle by opening and closing the valve according to the vehicle driving performance area."
            ImageSrc1="genswell_3_1.png"
            ImageSrc2="genswell_3_2.png"/>
        <FeatureSubs
            Card_subtitle=""
            Card_title="Popup Speaker"
            Card_description="Pop-up speakers are differentiated motorised-moving speaker devices that add smooth and natural performance effects when playing media."
            ImageSrc1="genswell_4_1.png"
            ImageSrc2="genswell_4_2.png"/>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import FeatureMain from '@/components/features/FeatureMain.vue'
import FeatureSubs from '@/components/features/FeatureSubs.vue'

export default {
  name: 'Genswell',
  components: {
    FeatureMain,
    FeatureSubs
  },
  
}
</script>
